import {
  requestJson,
} from '../../../shared/api/apiClient';

const CREATE_INQUIRY_ENDPOINT =
  '/api/contact/inquiries';

const CREATE_PUBLIC_INQUIRY_ENDPOINT =
  '/api/contact/public-inquiries';

export async function createInquiry(
  payload,
) {
  return requestJson(
    CREATE_INQUIRY_ENDPOINT,
    {
      method:
        'POST',

      body:
        JSON.stringify(
          payload,
        ),
    },
  );
}

export async function createPublicInquiry(
  payload,
) {
  return requestJson(
    CREATE_PUBLIC_INQUIRY_ENDPOINT,
    {
      method:
        'POST',

      body:
        JSON.stringify(
          payload,
        ),
    },
  );
}